import BaseRequest from './BaseRequest';

const schema = 'manager';
/**
 * key base on host:port
 */
export default class LoginRequest extends BaseRequest {
  /**
	 * @param {Object} params
	 * @param {string} params.step
	 * @param {string} params.code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  waitForConfirm(params) {
    const url = `${schema}/confirm`;
    return this.getWithTimeout(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.phone
	 * @param {string} params.password
	 * @param {string} params.term
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  register(params) {
    const url = `${schema}/create`;
    return this.post(url, params);
  }

  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  logout(params) {
    const url = `${schema}/logout`;
    return this.post(url, params);
  }

  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginQR1(params = {}) {
    const url = `${schema}/admin-login`;
    return this.getWithTimeout(url, params, 60 * 1000);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginQR2(params = {}) {
    const url = `${schema}/qr-verify`;
    return this.getWithTimeout(url, params, 60 * 1000);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginQR3(params = {}) {
    const url = `${schema}/qr-confirm`;
    return this.getWithTimeout(url, params, 60 * 1000);
  }
}
